/* MNTO OS - clock, reveal, form state. That is all it needs. */
(function () {
  'use strict';

  function reveal(root) {
    var n = (root || document).querySelectorAll('.os [data-r]:not(.in)');
    if (!n.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(n, function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        setTimeout(function () { el.classList.add('in'); }, parseInt(el.getAttribute('data-d') || '0', 10));
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    Array.prototype.forEach.call(n, function (e) { io.observe(e); });
  }

  function clock(root) {
    var els = (root || document).querySelectorAll('[data-os-clock]');
    if (!els.length) return;
    function tick() {
      var d = new Date();
      var h = d.getHours();
      var t = (h % 12 === 0 ? 12 : h % 12) + ':' + String(d.getMinutes()).padStart(2, '0') + ' ' + (h >= 12 ? 'PM' : 'AM');
      Array.prototype.forEach.call(els, function (e) { e.textContent = t; });
    }
    tick();
    if (!window.__osClock) window.__osClock = setInterval(tick, 20000);
  }

  function form(root) {
    var fs = (root || document).querySelectorAll('.os-form');
    Array.prototype.forEach.call(fs, function (f) {
      if (f.dataset.b === '1') return;
      f.dataset.b = '1';
      f.addEventListener('submit', function () {
        var b = f.querySelector('button[type="submit"]');
        if (b) { b.textContent = 'Sending'; b.disabled = true; }
      });
    });
  }

  /* PDP gallery: thumbs swap the main image. No library needed. */
  function gallery(root) {
    var sets = (root || document).querySelectorAll('[data-os-gal]');
    Array.prototype.forEach.call(sets, function (set) {
      if (set.dataset.b === '1') return;
      set.dataset.b = '1';
      var stage = document.getElementById('pdp-stage-' + set.getAttribute('data-os-gal'));
      if (!stage) return;
      set.addEventListener('click', function (ev) {
        var btn = ev.target.closest('.os-pdp__thumb');
        if (!btn) return;
        var img = stage.querySelector('img');
        if (!img) return;
        img.src = btn.getAttribute('data-src');
        img.alt = btn.getAttribute('data-alt') || '';
        Array.prototype.forEach.call(set.querySelectorAll('.os-pdp__thumb'), function (t) {
          t.removeAttribute('aria-current');
        });
        btn.setAttribute('aria-current', 'true');
      });
    });
  }

  /* Sticky buy bar: visible from the moment the page loads, stays fixed through the whole page. Markup already ships with the `in` class, this just guards against anything else on the theme stripping it. */
  function stick(root) {
    var bar = (root || document).querySelector('[data-os-stick]');
    if (!bar || bar.dataset.b === '1') return;
    bar.dataset.b = '1';
    bar.classList.add('in');
  }

  function boot(r) { reveal(r); clock(r); form(r); gallery(r); stick(r); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else { boot(document); }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
